import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { CustomSectionTitleComponentProps } from '../../../../common/SectionTitle';

export interface EditableSectionTitleProps extends CustomSectionTitleComponentProps {
  content: {
    editingTitle?: string;
  };
}

export const EditableSectionTitle = ({ content, title, isEditing, color }: EditableSectionTitleProps) => {
  const displayTitle = isEditing && content.editingTitle ? content.editingTitle : title;

  return (
    <Typography fontWeight="bold" size="b_md" style={{ whiteSpace: 'pre-line' }} {...(color && { color })}>
      {displayTitle}
    </Typography>
  );
};
